const {h, render, Component} = require('preact');
const {Portal} = require('preact-portal');
const EmailFormMainContainer = require('../../containers/email_form/email_form');
const ConfirmationPopup = require('../confirmation_popup/confirmation_popup')
const FlexibleFormUS = require('../../../../../flexible_forms/frontend/container/flexible_form_us')
const FlexibleFormEMEA = require('../../../../../flexible_forms/frontend/container/flexible_form_emea')
const CallUsView = require('../../views/contact_us/call_us');

class EmailView extends Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
    this.handleCloseConfirmationPopup = this.handleCloseConfirmationPopup.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
    this.handleCallUsLink = this.handleCallUsLink.bind(this);
    this.handleCallUsClose = this.handleCallUsClose.bind(this);
  };

  showPopUp(event){
    if(event.detail.type=='email'){
      this.setState({
        open: true, resetState: true
      });
    }
  }

  open() {
    if(document.getElementById("bc-layered-chat") || document.getElementById("bc-chat-container"))
    {
      var event = new CustomEvent('channel-switch',{detail: {type:'email'}});
      var channelsContainer = document.getElementsByClassName('all-channels')[0]
      if(channelsContainer)
      {
        channelsContainer.dispatchEvent(event);
        channelsContainer.addEventListener('show-popup', this.showPopUp, false);
      }
    }
    else{
      this.setState({
        open: true, resetState: true
      });
    }
  }

  handleClick() {
    this.setState({
        open: false, confirmationPopup: true, resetState: false
    });
  }

  handleCallUsLink() {
    this.setState({
        open: false, resetState: false, callUsPopup: true
    });
  }

  handleCallUsClose() {
    this.setState({
      open: true, resetState: false, callUsPopup: false
    });
  }

  handleBackButtonClick() {
    this.setState({
      open: true, confirmationPopup: false, resetState: false
    });
  }

  handleCloseButtonClick() {
    this.setState({
      open: false, resetState: true, confirmationPopup: false
    });
  }

  handleCloseConfirmationPopup() {
    this.setState({
      confirmationPopup: false,
      open: true,
      resetState: false
    })
  }

  getTranslationObject(){
    var translationObject = {}
    translationObject.closeText = I18n.translate('js.modules.web_2018.close_text_form')
    translationObject.selectingText = I18n.translate('js.modules.web_2018.selecting_text_email')
    translationObject.sureText = I18n.translate('js.modules.web_2018.sure_text_email')
    translationObject.backButtonText = I18n.translate('js.modules.web_2018.back_button_form')
    translationObject.closeButtonText = I18n.translate('js.modules.web_2018.close_button_form')
    return translationObject;
  }

  getEmailIcon(emailConfig) {
    return (
      <div class={!emailConfig.isAvailable?'channel-unavailable':'channel-available'} aria-label="EmailButton" onClick={this.open}>
        <table class={!emailConfig.isAvailable?'channel-grid  channel-unavailable':'channel-grid'} data-bhw={emailConfig.bhw}>
          <tr>
            <td class="channel-icon-section">
              <span class={!emailConfig.isAvailable?'icon-email channel-icon  channel-unavailable':'icon-email channel-icon'}></span>
            </td>
            <td class="channel-text-section">
              <span class={!emailConfig.isAvailable?'channel-text  channel-unavailable':'channel-text'}>{emailConfig.channelText}</span> <br></br>
              <span class={!emailConfig.isAvailable?'channel-msg   channel-unavailable':'channel-msg'}>{emailConfig.channelMsg}</span>
            </td>
          </tr>
        </table>
      </div>
    );
  }

  getEmailLink(emailConfig) {
    return (
      <span id="email_link" class={!emailConfig.isAvailable ? 'channel-text-unavailable' : 'channel-text-available'}
            aria-label="EmailLink" onClick={this.open} data-bhw={emailConfig.bhw + "_link"}>
        {I18n.translate("js.modules.web_2018.send_email")}
      </span>
    );
  }

  getFormObjectForEMEAOrUS() {
      if (this.configFromDom.isRegionNAandBrandGroupon) {
        if (this.configFromDom.flexibleFormEnabledUS)
            return FlexibleFormUS
      }
      else {
        if (this.configFromDom.flexibleFormEnabledEMEA)
            return FlexibleFormEMEA
      }
    return EmailFormMainContainer
  }

  render() {
    if(this.props.params){
      let FormObject = this.getFormObjectForEMEAOrUS()
      let emailConfig = this.props.params.contactChannels.email;
      let shouldShowEmailButtonLayout = this.props.params.shouldShowEmailButtonLayout;
      let emailButtonDisabled = this.configFromDom.showNewChannelLayoutInWeb2018;
      return (<div class={(emailButtonDisabled && !shouldShowEmailButtonLayout) ? null : 'email-channel-container'}>
          { (emailButtonDisabled && !shouldShowEmailButtonLayout) ?  this.getEmailLink(emailConfig) : this.getEmailIcon(emailConfig)}
          { this.state.open ? (
              <Portal into="body">
                  <div class={'popup new-channel-experience'}>
                      <FormObject handleCallUsLink={this.handleCallUsLink} handleClick = {this.handleClick} resetState = {this.state.resetState} contactChannelParams = {this.props.contactChannelParams} contactChannelConfig={this.props.params.contactChannels} guestOrder={this.props.guestOrder}/>
                  </div>
                <div class = "shadow"></div>
              </Portal>
          ): null
          }
          {this.state.confirmationPopup ? (
            <Portal into= "body">
              <div class="popup">
                <ConfirmationPopup handleCloseConfirmationPopup = {this.handleCloseConfirmationPopup} handleBackButtonClick = {this.handleBackButtonClick}
                                  handleCloseButtonClick = {this.handleCloseButtonClick} translationObject = {this.getTranslationObject()}/>
              </div>
              <div class = "shadow"></div>
            </Portal>
          ): null
          }
          {this.state.callUsPopup ? (
            <Portal into="body">
              <div class="popup call-us-height">
                <CallUsView handleCallUsClose={this.handleCallUsClose}/>
              </div>
              <div class="shadow"></div>
            </Portal>
          ) : null
          }
        </div>
      )
    }
    return null;
}
}
module.exports = EmailView
